export * from './confirm-email-page.component';
export * from './confirm-email-page.module';
